import isObject from "../utils/isObject.js";
import isPromise from "../utils/isPromise.js";

export default {
  inject: ["master"],

  props: {
    id: {
      type: String,
      required: true
    },

    label: {
      type: String
    },

    // 初始化值
    initData: {
      type: [Object, null]
    },

    // 是否为单选模式
    singleMode: {
      type: Boolean,
      default: false
    },

    // 此组件是否支持 单选模式
    // 如果Top组件是单选模式，而此「 plugin 」不支持单选模式的话，将不再向上注册
    supportSingleMode: {
      type: Boolean,
      default: false
    },

    // 是否需要必须选择一个商品
    required: {
      type: Boolean,
      default: false
    },

    // 配置项
    setting: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  watch: {
    initData: {
      handler: "compInit",
      immediate: true
    }
  },

  mounted() {
    this.registerSelf();
  },

  beforeDestroy() {
    this.unRegisterSelf();
  },

  methods: {
    // init
    async compInit(value) {
      if (!value) return;

      // 考虑部分组件自定义的 mergeInit 是一个异步函数
      let task = this.mergeInit(value);

      if (isPromise(task)) {
        await task;
      }

      this.afterCompInit && this.afterCompInit();
    },

    // todo deepMerge
    // data merge
    // 这是默认的 dataMerge
    // 部分组件根据业务自定义 dataMerge 覆盖此方法
    mergeInit(data) {
      if (!isObject(data)) return;
      for (let property in data) {
        if (this.form.hasOwnProperty(property)) {
          this.$set(this.form, property, data[property]);
        }
      }
    },

    // 表单验证
    formValidator() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            // 部分组件会根据业务需要提交一个 customize 的数据
            // dataCustomize 就是部分组件自定的方法
            // 用于提交数据钱的 数据格式化
            if (this.dataCustomize) {
              this.dataCustomize(resolve);
            } else {
              resolve(this.form);
            }
          } else {
            reject(this.form);
          }
        });
      });
    },

    // 触发这个验证函数
    async validator() {
      // 验证第一步： 必填性验证
      // 如果product picker 接受了一个required = true 的 prop
      // 需要调用当前激活的插件的自定义的 requiredValidator 方法
      // requiredValidator 是一个同步函数 返回 true or false
      // 如果验证失败 向上emit一个“required-valid-error”的事件
      if (
        this.required &&
        this.requiredValidator &&
        !this.requiredValidator()
      ) {
        // output
        console.warn("ProductsPicker: 至少选择一个商品");

        // emit
        this.master && this.master.toggleRequiredErrorMsgVisible(true);

        // reject
        return Promise.reject();
      }

      // 验证第二步
      // 验证组件内的表单
      return await this.formValidator();
    },

    // 向Top组件注册
    registerSelf() {
      const { label, id } = this;

      if (!this.master) {
        console.warn(
          "[Product Picker] 此组件需要作为ProductPickerPanel的子组件"
        );
        return;
      }

      // 如果是单选模式 且该组件不支持单选的话 不向TOP注册
      if (this.singleMode && !this.supportSingleMode) {
        return;
      }

      this.master.registerPlugin({
        label: label || id,
        id,
        validator: this.validator.bind(this)
      });
    },

    // 向Top组件注销自己
    unRegisterSelf() {
      if (!this.master) {
        console.warn(
          "[Product Picker] 此组件需要作为ProductPickerPanel的子组件"
        );
        return;
      }

      // 如果是单选模式且该组件不支持单选的话 就不再向TOP注册自己
      if (this.singleMode && !this.supportSingleMode) {
        return;
      }

      this.master.unregisterPlugin({
        id: this.id
      });
    }
  }
};
